const lightenRgb = (rgb, percent) => {
    const [r, g, b] = rgb
      .replace(/[^\d,]/g, '')
      .split(',')
      .map(Number);
  
    const lighten = (c) => Math.min(255, Math.floor(c + (255 - c) * percent / 100));
  
    return `rgb(${lighten(r)}, ${lighten(g)}, ${lighten(b)})`;
  };

  export default lightenRgb;